@reference "@glow/tailwind-config/reference.css";

.badge {
  @apply w-2.5;
  @apply h-2.5;
  @apply rounded-full;
}

.SUCCESS {
  @apply bg-success-dark;
}

.WARNING {
  @apply bg-warning-dark;
}

.DANGER {
  @apply bg-danger-dark;
}

.NEUTRAL {
  @apply bg-emphasis-high;
}

.LIGHT {
  @apply text-emphasis-high;
  @apply bg-gray-200;
}

.DARK {
  @apply bg-neutral-700;
}

.BLUE {
  @apply bg-blue-700;
}
